/**
 * Created by Jason on 2017-5-24.
 */

//上传中
import fullLoading from '../lib/full-loading/full-loading';
import '../lib/full-loading/full-loading.css';

//编辑器
import Editor from '../../assets/js/editor';

//二维码
import '../lib/jquery-qrcode/jquery-qrcode';
//下载
import download from './download';
import '../css/download.css';

//文件上传框
import '../lib/upload-box/index.css';
import UploadBox from '../lib/upload-box';

//弹窗
import bootBox from '../../assets/lib/bootbox/bootbox';
import util from '../../assets/js/util';

const mathArray = ['', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二'];
let statusOptions = {
    2: {
        class: 'text-normal',
        text: '待审核'
    },
    3: {
        class: 'text-danger',
        text: '已驳回'
    },
    4: {
        class: 'text-success',
        text: '已完成'
    },
    5: {
        class: 'text-danger',
        text: '已撤回'
    }

};

/**
 * 合同详情
 */
class ContractDetail {
    constructor(el, userData, callbacks, isReply = true) {
        let ts = this;
        ts.$el = $(el).eq(0);
        ts.userData = userData;
        ts.isReply = isReply;
        ts._renderDom();
        ts._contractEvent();
        ts.callbacks = callbacks;
        ts.company = null;
        ts._toUp();
        download.addListener(ts.$el);
    }

    /**
     * 初始渲染
     * @private
     */
    _renderDom() {
        let ts = this;
        let $el = ts.$el;
        $el.addClass('topic-box');
        if (ts.isReply) {
            $el.css('paddingBottom', 100);
        }
        $el.html(
            ` <div class="topic-content">
                    <div class="topic-scroll" class="topic-scroll">
                        <div class="topic-detail">
                        </div>
                        <div class="topic-reply-list"><div class="empty">正在加载数据...</div></div>
                    </div>
                    <a href="javascript:;" class="fa fa-angle-up to-topic-top">TOP</a>
                </div>`
        );
        ts.$contractScroll = $el.find('.topic-scroll');
        ts.$contractDetail = $el.find('.topic-detail').eq(0);
        ts.$contractReplyList = $el.find('.topic-reply-list');
        ts.ContractTeplyListData = [];
        if (ts.isReply) {
            ts._initReply();
        }
    }

    /**
     * 合同按钮事件
     */
    _contractEvent() {
        let ts = this;
        let isSubmit = false;
        ts.$contractDetail.on('click', '.topic-btn', (e) => {
            if (!ts.contractId) {
                return;
            }
            if (isSubmit) {
                return;
            }
            let $t = $(e.target);
            let type = $t.data('type');
            let contractId = ts.contractId;
            switch (type) {
                case 'send':
                    {
                        util.confirm('确定要发送给客户吗？', () => {
                            check(4);
                        }, true);
                        break;
                    }

                case 'reject':
                    {
                        util.confirm('确定要驳回吗？', () => {
                            check(3);
                        }, true);
                        break;
                    }

                case 'cancel':
                    {
                        util.confirm('确定要撤回吗？', () => {
                            isSubmit = true;
                            $.post(SERVER + '/order/revoke', {
                                contractId: contractId,
                                contractStatus: 5
                            }, (json) => {
                                if (json.status == 0) {
                                    ts.callbacks && ts.callbacks.changeStatus(contractId, 3);
                                }
                                ts.getContractDetail();
                                isSubmit = false;
                            });
                        }, true);
                        break;
                    }

                case 'edit':
                    {
                        if (!ts.contractDetail) {
                            return;
                        }
                        ts.callbacks && ts.callbacks.edit(ts.contractDetail);
                        break;
                    }
                case 'del':
                    {

                        let contractDetail = ts.contractDetail;
                        if (!contractDetail || contractDetail.contractStatus !== 5 && contractDetail.contractStatus !== 3) {
                            return;
                        }
                        util.confirm('确定要删除这个合同吗？', () => {
                            isSubmit = true;
                            $.post(SERVER + '/order/delete', {
                                contractId: contractDetail.contractId
                            }, (json) => {
                                isSubmit = false;
                                if (json.status == 0) {
                                    ts.contractId = 0;
                                    ts.callbacks && ts.callbacks.delete(contractDetail.contractId);
                                }
                            });
                        });
                        break;
                    }
                case 'email':
                    {
                        ts._toEmail();
                    }
            }

            function check(status) {
                isSubmit = true;
                $.post(SERVER + '/order/editContractStatus', {
                    contractId: contractId,
                    contractStatus: status
                }, (json) => {
                    if (json.status == 0) {
                        ts.callbacks && ts.callbacks.changeStatus(contractId, status);
                    }
                    ts.getContractDetail();
                    isSubmit = false;
                });
            }
        });
        /**
         * web版二维码
         */
        ts.$contractDetail.on('mouseover', '.wechat-web-btn', (e) => {
            let $t = $(e.target);
            let id = $t.data('id') - 0;
            if (!id) {
                return;
            }
            $t.find('.qr-code').eq(0).qrcode({
                // render method: 'canvas', 'image' or 'div'
                render: 'canvas',
                minVersion: 1,
                maxVersion: 40,
                ecLevel: 'L',
                left: 0,
                top: 0,
                size: 160,
                fill: '#000',
                background: null,
                text: 'http://m.custom.orancrab.com/topic.html?id=' + id,
                radius: 0,
                quiet: 0,
                mode: 0,
                mSize: 0.1,
                mPosX: 0.5,
                mPosY: 0.5,
                label: '',
                fontname: 'sans',
                fontcolor: '#ec6a03',
                image: null
            });
            $t.data('id', 0);
        });
        /**
         * 小程序二维码
         */
        ts.$contractDetail.on('mouseover', '.wechat-app-btn', (e) => {
            let $t = $(e.target);
            let id = $t.data('id') - 0;
            if (!id) {
                return;
            }
            let $qrCode = $t.find('.qr-code').eq(0);
            $qrCode.html('正在生成二维码，请稍侯...');
            let $img = $(new Image());
            $img.on('load', () => {
                $qrCode.html($img);
                //修复IE11自动加宽高
                setTimeout(() => {
                    $img.attr('height', 'auto');
                });
            });
            $img.on('error', () => {
                $qrCode.html('生成失败，系统错误。');
            });
            $img.attr('src', SERVER + '/wechat/getWXAQRCode?path=' + encodeURIComponent('pages/topic/topic?contractId=' + id) + '&width=200');
            $t.data('id', 0);
        });
    }

    /**
     * 处理邮件外发
     * @private
     */
    _toEmail() {
        let ts = this;
        if (!ts.company) {
            $.get(SERVER + '/company/companyDetail', {
                'companyId': ts.contractDetail.companyId
            }, (json) => {
                if (json.status === 0) {
                    ts.company = json.data;
                    ts._emailBox(json.data.companyEmail);
                } else {
                    ts._emailBox('');
                }
            });
        } else {
            ts._emailBox(ts.company.companyEmail || '');
        }

    }

    /**
     * emial弹窗
     * @param email
     * @private
     */
    _emailBox(email) {
        let ts = this;
        bootBox.prompt({
            title: '邮件外发合同',
            size: 'small',
            value: email,
            buttons: {
                confirm: {
                    label: '发送',
                    className: 'btn-primary'
                },
                cancel: {
                    label: '取消',
                    focus: true
                }
            },
            inputType: 'email',
            callback(result) {
                if (result == null) {
                    return;
                }
                if (!util.isEmail(result)) {
                    util.error('邮箱地址格式错误');
                    return;
                }
                $.post(SERVER + '/topic/sendTopicToEmail', {
                    'contractId': ts.contractId,
                    'email': result.trim()
                }, (json) => {
                    if (json.status == 0) {
                        util.success('邮件发送成功');
                    }
                });
            }
        });
    }

    /**
     * 获取合同
     * @param contractId
     * @param company
     * @param callback
     */
    getContract(contractId,  callback) {
        let ts = this;
        if (ts.isReply) {
            ts.emptyReply(true);
        }
        if (!contractId) {
            callback(false);
            return;
        }
        // ts.company = company;
        if (ts.contractId !== contractId) {
            //需要暂停语音和播放
            download.stopAudio();
        }
        ts.contractId = contractId;
        ts.getContractDetail((result) => {
            if (!result) {
                callback(false);
                return;
            }
            $.get(SERVER + '/companyContractReply/getReplyList', {
                'contractId': ts.contractId,
                'pageSize': 1000
            }, (json) => {
                if (json.status == 0) {
                    ts.contractTeplyListData = json.data.content;
                    ts._renderReplyList(json.data);
                    callback(true);
                } else {
                    callback(false);
                }
            });
        });
    }

    /**
     * 获取合同详情
     * @returns {*}
     */
    getContractDetail(cb) {

        let ts = this;
        if (!ts.contractId) {
            cb(false);
            return;
        }
        return $.get(SERVER + '/order/detail', {
            'contractId': ts.contractId
        }, (json) => {
            if (json.status == 0) {
                ts.contractDetail = json.data;
                if (cb) {
                    cb(true);
                }
                ts._renderContract(json.data);
            } else {
                cb(false);
                ts.contractDetail = null;
            }
        });
    }

    /**
     * 渲染合同
     * @param topic
     */
    _renderContract(topic) {
        let ts = this;
        let userData = ts.userData;
        let html = `<div class="topic-menu">
            <div class="user-box">
                <img src="${topic.headImg ? SERVER + '/upload/image/' + topic.headImg : '/img/default-head.png'}">
                <span class="user-name">${topic.userName + '（' +
    (topic.identityType ? util.getIdentityName(topic) : '客户') + '）'}</span>
                <span class="time">${util.getTimeStr(topic.addTime)}</span>
            </div>
         `;

        if (topic.contractStatus == 2 && userData.identityType === 'REVIEW_STAFF') {
            html += `<a href="javascript:;" class="btn btn-default btn-sm fa fa-send-o topic-btn" data-type="send"> 发送给客户</a>
                <a href="javascript:;" class="btn btn-default btn-sm fa fa-rotate-left topic-btn" data-type="reject"> 驳回</a>
                `;
        }

        if (topic.contractStatus == 2 && userData.identityType === 'SERVICE_STAFF' && userData.userId == topic.serviceUserId) {
            html += `<a href="javascript:;" class="btn btn-default btn-sm fa fa-rotate-left topic-btn" data-type="cancel"> 撤回</a>`;
        }
        if ((topic.contractStatus == 3 || topic.contractStatus == 5) && userData.identityType === 'SERVICE_STAFF' && userData.userId == topic.serviceUserId) {
            html += `
                        <a href="edit-order.html?contractId=${topic.contractId}"  class="btn btn-default btn-sm fa fa-edit topic-btn" data-type="edit">编辑</a>
                        <a href="javascript:;" class="btn btn-default btn-sm fa fa-trash-o topic-btn" data-type="del"> 删除</a>`;
        }
        // if (topic.contractStatus == 4) {
        //   if (userData.userId == topic.serviceUserId) {
        //     html += `<a href="javascript:;" class="btn btn-default btn-sm fa fa-envelope-o email topic-btn" data-type="email" data-id="${topic.contractId}"> 邮件外发</a>`;
        //   }
        //   html += `<a href="javascript:;" class="btn btn-default btn-sm fa fa-qrcode wechat-btn wechat-web-btn" data-id="${topic.contractId}"> 微信网页<span class="qr-code"></span></a>`;
        //   html += `<a href="javascript:;" class="btn btn-default btn-sm fa fa-qrcode wechat-btn wechat-app-btn" data-id="${topic.contractId}"> 微信小程序<span class="qr-code"></span></a>`;
        // }

        html += `</div>
            <h1>${topic.contractTitle} </h1>
            <div class="table-item"><span class="detail-label">客户</span><span>${topic.companyName}</span></div>`;

        topic.orderVoList && topic.orderVoList.forEach((item,index) => {
            html += `<div class="table-item"><span class="detail-label">产品${index+1}</span><span>${item.productName}</span></div>
            <div class="table-item"><span class="detail-label">服务起止时间</span><span>${util.getYearMonthDaySimple(item.startTime)} - ${util.getYearMonthDaySimple(item.endTime)}</span></div>
            <div class="table-item"><span class="detail-label">付款方式</span><span>${mathArray[item.payManner]}次付款</span></div><div class="table-item"><span class="detail-label">应付款时间</span>`;
            item.payTimeList && item.payTimeList.forEach((value, index) => {
                html += `<span>${mathArray[index+1]}次付款时间 &nbsp ${util.getYearMonthDaySimple(value.payTime)} &nbsp </span>`;
            });
            html+=`</div>`
        });
        html += `<div class="content">${topic.contractDescription}</div>`;
        if (topic.attachmentFileList && topic.attachmentFileList.length) {
            html += download.renderList(topic.attachmentFileList);
        }

        if (topic.viewRecord && topic.viewRecord.length) {
            html += '<div class="view-record">';
            topic.viewRecord.forEach((view) => {
                html += `<i class="fa fa-check"></i>${view.name}<span>${util.formatDate(view.time)} 查看了该内容</span>`;
            });
            html += '</div>';
        }
        ts.$contractDetail.html(html);
    }

    /**
     * 渲染回复列表
     * @private
     */
    _renderReplyList(data) {
        let ts = this;
        if (!data.content || !data.content.length) {
            ts.$contractReplyList.html('<div class="empty">没有回复</div>');
            return;
        }
        let html = ``;
        data.content.forEach((detail) => {
            html += ts._renderReply(detail);
        });
        ts.$contractReplyList.html(html);
    }

    /**
     * 渲染单个回复
     * @param detail
     */
    _renderReply(detail) {
        let addUserInfo = detail.addUserInfo;
        let html = '<div><div class="reply-menu">';
        html += `</div>
                <div class="user-box">
                <img src="${addUserInfo.headImg ? SERVER + '/upload/image/' + addUserInfo.headImg : '/img/default-head.png'}">
                <span class="user-name">
                ${addUserInfo.name + '（' +
    (addUserInfo.title ? addUserInfo.title : ((util.getIdentityName(addUserInfo) || '客户')) ) + '）'}
                </span>
                <span class="time">${util.getTimeStr(detail.replyTime)}</span>
            </div>
            <div class="content">${detail.content}</div>`;
        if (detail.attachmentFiles && detail.attachmentFiles.length) {
            html += download.renderList(detail.attachmentFiles);
        }
        html += `</div>`;
        return html;
    }

    /**
     * 初始化回复
     * @private
     */
    _initReply() {
        let ts = this;
        let $el = ts.$el;
        $el.append(`<div class="reply-box"><div class="reply-edit" contenteditable="true" placeholder="请输入回复内容，5-5000字。"></div>
                <div class="reply-bar">
                    <label class="btn btn-default add-files fa fa-paperclip"> 附件(0)</label>
                    <div class="buttons">
                        <button class="btn btn-danger abandon" type="button">放弃</button>
                        <button class="btn btn-success submit" type="button">回复</button>
                    </div>
                </div>
                </div>`);
        let $replyBox = ts.$replyBox = $el.find('.reply-box');
        let $replyEdit = ts.$replyEdit = $replyBox.find('.reply-edit');
        let $replyFileButton = $replyBox.find('.add-files');

        new Editor($replyEdit);

        //获取焦点，展开
        $replyEdit.on('focus', function() {
            $el.animate({ paddingBottom: 400 });
            $replyBox.animate({ height: 400 });
            ts.replyShow = true;
        });
        //取消
        $replyBox.find('.abandon').on('click', function() {
            //取消回复
            ts.smallReply(true);
        });
        //上传文件框处理
        let uploadFiles = [];

        //上传框
        let uploadBox = ts.replyUploadBox = new UploadBox({
            confirm: (remotes, uploads) => {
                uploadFiles = uploads;
                $replyFileButton.html(' 附件(' + (uploads.length) + ')');
            },
            cancel: () => {
                uploadFiles = [];
                $replyFileButton.html(' 附件');
            },
            maxAllNumber: 10,
            maxAllSize: 100 * 1000 * 1000,
            el: $replyFileButton,
            key: 'reply'
        });

        $replyFileButton.on('click', () => {
            uploadBox.show({
                uploadFiles: uploadFiles
            });
        });
        //提交
        let isSubmit = false;
        $replyBox.find('.submit').on('click', (e) => {
            if (!ts.contractId) {
                return;
            }
            if (isSubmit) {
                return;
            }
            let content = $replyEdit.trumbowyg('html');
            let contentFilter = util.htmlLength(content);
            if (contentFilter < 5) {
                util.error('回复内容至少输入5个字');
                return false;
            }
            if (contentFilter > 5000) {
                util.error('回复内容不能超过5000字');
                return false;
            }

            let formData = new FormData();
            formData.append('content', content);
            formData.append('contractId', ts.contractId);
            uploadFiles.forEach((file) => {
                formData.append('replyFiles[]', file);
            });
            isSubmit = true;
            fullLoading.show();
            $.ajax({
                type: 'POST',
                url: SERVER + '/companyContractReply/addReply',
                data: formData,
                processData: false,
                contentType: false,
                success(json) {
                    if (json.status == 0) {
                        //回复成功
                        ts.smallReply();
                        util.success('回复成功');
                        uploadBox.cancel();
                        if (!ts.contractTeplyListData || !ts.contractTeplyListData.length) {
                            ts.contractTeplyListData = [json.data];
                            ts.$contractReplyList.html(ts._renderReply(json.data));
                        } else {
                            ts.$contractReplyList.append(ts._renderReply(json.data));
                            ts.$contractScroll.scrollTop(ts.$contractScroll[0].scrollHeight);
                        }
                    }
                },
                complete() {
                    isSubmit = false;
                    fullLoading.hide();
                }
            });
        });
    }

    /**
     * 最小化输入框
     * @param isConfirm
     */
    smallReply(isConfirm) {
        let ts = this;
        if (!ts.replyShow) {
            if (typeof isConfirm === 'function') {
                isConfirm();
            }
            return;
        }
        let content = ts.$replyEdit.trumbowyg('html');
        if (isConfirm &&
            (content)) {
            util.confirm('是否放弃当前编辑内容？', () => {
                ts.emptyReply(content);
                if (typeof isConfirm === 'function') {
                    isConfirm();
                }
            });
            return;
        }
        ts.emptyReply(content);
        if (typeof isConfirm === 'function') {
            isConfirm();
        }
    }

    /**
     * 清空回复内容
     * @param content
     */
    emptyReply(content) {
        let ts = this;
        ts.$el.animate({ paddingBottom: 100 });
        ts.$replyBox.animate({ height: 100 });
        ts.replyUploadBox.cancel();
        if (content) {
            ts.$replyEdit.trumbowyg('empty');
        }
        //是否已经显示
        ts.replyShow = false;
    }

    /**
     * 回到顶部
     */
    _toUp() {
        let ts = this;
        let $contractScroll = ts.$contractScroll;
        let $toContractTop = ts.$el.find('.to-topic-top');
        $contractScroll.on('scroll', (e) => {
            if ($contractScroll.scrollTop() > 200) {
                $toContractTop.stop().fadeIn(200);
            } else {
                $toContractTop.stop().fadeOut(200);
            }
        });
        $toContractTop.on('click', () => {
            $contractScroll.animate({
                'scrollTop': 0
            });
        });
    }
}

module.exports = ContractDetail;



// WEBPACK FOOTER //
// ./src/assets/js/contract-detail.js